export default __webpack_public_path__ + "static/media/602.206f2340.jpg";